/// <reference path="../../index.d.ts"/>

requirejs.config({'baseUrl': '', 'paths': {'lodash': '/libs/lodash/lodash.min'}});

// clone 对象
Object.clone = (obj) => {
  return JSON.parse(JSON.stringify(obj))
}

// 为Date类型提供简单的格式化支持
Date.format = function (date: Date, fmt: string): string {
  let o: { [key: string]: number } = {
    "M+": date.getMonth() + 1,
    "d+": date.getDate(),
    "h+": date.getHours(),
    "m+": date.getMinutes(),
    "s+": date.getSeconds(),
    "q+": Math.floor((date.getMonth() + 3) / 3),
    S: date.getMilliseconds()
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (let k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k].toString() : ("00" + o[k]).substr(("" + o[k]).length));
  return fmt;
};

Date.prototype.format = function (fmt: string): string {
  return Date.format(this, fmt);
};


// 为Number提供格式化金额的方法
Number.formatMoney = function (value: number, sign?: boolean): string {
  let sstr = value >= 0 ? (sign ? '+' : '') : '-';
  let vstr = Math.floor(Math.abs(value) * 100).toString();
  if (vstr == 'NaN')
    return '0.00';
  if (vstr.length == 1)
    return '0.0' + vstr;
  if (vstr.length == 2)
    return '0.' + vstr;
  let result = '.' + vstr.substr(-2);
  vstr = vstr.substr(0, vstr.length - 2);
  while (vstr.length > 3) {
    result = ',' + vstr.substr(-3) + result;
    vstr = vstr.substr(0, vstr.length - 3);
  }
  return sstr + vstr + result;
};


// JSON 插件，用于加载JSON文件
define('json', function (require: Require) {

  function json(name: string, callback: any) {
    let onErrorOccurred = callback.error || function (e: Error) {
      throw e;
    };
    let xhr = new XMLHttpRequest();

    xhr.open('GET', require.toUrl(name + '.json'), true);
    xhr.onreadystatechange = function () {
      if (this.readyState != 4)
        return;
      try {
        if (this.status != 200)
          throw new Error('Faild to load json, HTTP status ' + this.status + '.');
        let exportName = name.replace(/^(\w)|[\-_](\w)/g, function (_$0, $1, $2) {
          return ($1 || $2).toUpperCase()
        });
        let object = JSON.parse(this.responseText), exports = {};
        Object.defineProperty(exports, '__esModule', {value: true});
        Object.defineProperty(exports, exportName, {value: object});
        Object.defineProperty(exports, 'default', {value: object});
        callback(exports);
      } catch (e) {
        onErrorOccurred(e);
      }
    }.bind(xhr);

    xhr.send();
  }

  json.load = function (name: string, _require: Require, onload: Function, config: { [key: string]: any }) {
    if (config.isBuild)
      return onload(null)
    this(name, onload);
  }

  return json;

});


// 配置文件封装，用于存取localStorage和sessionStorage
define('preferences', function () {

  class MemoryStorage implements Storage {

    [name: string]: any;

    private readonly values: Map<string, string> = new Map();

    get length(): number {
      return this.values.size;
    };

    clear(): void {
      this.values.clear();
    }

    getItem(key: string): string {
      return this.values.get(key);
    }

    key(_index: number): string {
      throw new Error("Method not implemented.");
    }

    removeItem(key: string): void {
      this.values.delete(key);
    }

    setItem(key: string, value: string): void {
      this.values.set(key, value);
    }

  }

  class Preferences {

    private static readonly objkeys: { [key: string]: Object } = {};
    private static readonly objects: WeakMap<Object, Preferences> = new WeakMap();
    private static readonly SYMBOL: Symbol = Symbol();

    private readonly storage: Storage;
    private readonly key: string;

    private data: { [key: string]: any } = {};

    constructor(symbol: Symbol, key: string, type: 'session' | 'local') {
      // 使用Symbol防止用户直接用new关键词创建对象
      if (symbol !== Preferences.SYMBOL)
        throw new Error('Use Preferences.load(key, type) instead.');

      // 生成用于在storage中存储数据的key
      this.key = `chuangshi://preferences/${key}`;

      // 根据type选用对应的storage
      switch (type) {
        case 'session':
          this.storage = sessionStorage;
          break;
        case 'local':
          this.storage = localStorage;
          break;
        default:
          throw new Error(`Unknown storage type: ${type}`);
      }

      // 检查storage能正常工作，不能则使用MemoryStorage做补丁
      try {
        const random: string = `*#*test:${Math.floor(Math.random() * 100000000)}*#*`;
        this.storage.setItem(random, random);
        if (this.storage.getItem(random) != random)
          throw new Error('Storage cannot work');
        this.storage.removeItem(random);
      } catch (e) {
        console.warn(`${type}Storage cannot work, fallback to memoryStorage!`);
        this.storage = new MemoryStorage();
      }

      // 加载数据
      this.load();
    }

    load() {
      let json = this.storage.getItem(this.key) || '{}';
      this.data = JSON.parse(json);
      return this;
    }

    put(key: string, value: any): Preferences {
      this.data[key] = value;
      return this;
    }

    get(key: string): any {
      return this.data[key];
    }

    clear(): Preferences {
      this.data = {};
      return this;
    }

    get raw(): { [key: string]: any } {
      return this.data;
    }

    commit(): void {
      let json = JSON.stringify(this.data)
      this.storage.setItem(this.key, json);
    }

    static load(key: string, type: 'session' | 'local'): Preferences {
      let objkey = Preferences.objkeys[key];
      if (!objkey)
        objkey = Preferences.objkeys[key] = new Object();

      let object = Preferences.objects.get(objkey);
      if (object)
        return object;

      object = new Preferences(Preferences.SYMBOL, key, type);
      Preferences.objects.set(objkey, object);
      return object;
    }

  }

  Object.defineProperty(Preferences, '__esModule', {value: true});
  Object.defineProperty(Preferences, 'Preferences', {value: Preferences});
  Object.defineProperty(Preferences, 'default', {value: Preferences});

  return Preferences;

});


// 一个轻量级的Shabbydown格式转html的转换器
define('shabbydown', function() {

  class Shabbydown {

    constructor() {
      throw new Error('This class can not be instantiated');
    }

    static toHTML(content: string, baseuri?: string) {
      if (!content)
        return content;

      let lines = content.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/\r/g, '').split('\n');

      let result = '<p>';
      baseuri = baseuri || '';

      for (let i = 0, prev = true; i < lines.length; ++i) {
        let line = lines[i].replace(/\s{2,}/g, function(matched) {
          let nbsps = '';
          for (let i = 0; i < matched.length; ++i)
            nbsps += '&nbsp;';
          return nbsps;
        });

        if (line.trim()) {
          if (!prev)
            result += '<br>';
          prev = false;
          result += line.replace(/\[(h[1-6])(#[0-9A-Fa-f]{6})?\[(.+?)\]\]/g, function(_raw: string, tagName: string, color: string, text: string): string {
            return '</p><' + tagName + (color ? ' style="color:' + color + '">' : '>') + text + '</' + tagName + '><p>';
          }).replace(/\[(del|em|ins|mark|span|strong|sub|sup)(#[0-9A-Fa-f]{6})?\[(.+?)\]\]/g, function(_raw: string, tagName: string, color: string, text: string): string {
            return '<' + tagName + (color ? ' style="color:' + color + '">' : '>') + text + '</' + tagName + '>';
          }).replace(/\[image\((.+?)\)\]/g, function(_raw: string, uri: string): string {
            if (!uri.match(/^https?:\/\//))
              uri = baseuri + uri;
            return '</p><p><img src="' + uri + '"></img></p><p>';
          }).replace(/\[(audio|video)\((.+?)\)\]/g, function(_raw: string, tagName: string, uri: string): string {
            if (!uri.match(/^https?:\/\//))
              uri = baseuri + uri;
            return '</p><p><' + tagName + ' src="' + uri + '" controls="controls"></' + tagName + '></p><p>';
          }).replace(/\[link\[(.+?)\]\((.+?)\)\]/g, function(_raw: string, text: string, uri: string) {
            if (!uri.match(/^https?:\/\//))
              uri = baseuri + uri;
            return '<a href="' + uri + '" target="_blank">' + text + '</a>';
          }).replace(/\[image:([A-Za-z0-9\-_:\/\.]+\.(png|jpg|jpeg|gif))\]/g, function(_raw: string, uri: string) {
            if (!uri.match(/^https?:\/\//))
              uri = baseuri + uri;
            return '</p><p><img src="' + uri + '"></img></p><p>';
          }).replace(/\[audio:([A-Za-z0-9\-_:\/\.]+\.(mp3|wav|ogg))\]/g, function(_raw: string, uri: string) {
            if (!uri.match(/^https?:\/\//))
              uri = baseuri + uri;
            return '</p><p><audio src="' + uri + '" controls="controls"></audio></p><p>';
          }).replace(/\[(sub|sup)\:(.*?)\]/g, function(_raw: string, tag: string, text: string) {
            return '<' + tag + '>' + text + '</' + tag + '>';
          }).replace(/\*\*(.*?)\*\*/g, function(_raw: string, text: string) {
            return '<strong>' + text + '</strong>';
          }).replace(/~~(.*?)~~/g, function(_raw: string, text: string) {
            return '<del>' + text + '</del>';
          }).replace(/__(.*?)__/g, function(_raw: string, text: string) {
            return '<ins>' + text + '</ins>';
          });
        } else {
          if (!prev)
            result += '</p><p>';
          prev = true;
        }
      }

      return (result += '</p>').replace(/(<br>)?(<\/?p>)(<br>)?/g, (_raw: string, _br1: string, tag: string, _br2: string): string => tag)
        .replace(/<p><\/p>/g, '');
    }

  }

  Object.defineProperty(Shabbydown, '__esModule', { value: true });
  Object.defineProperty(Shabbydown, 'Shabbydown', { value: Shabbydown });
  Object.defineProperty(Shabbydown, 'default', { value: Shabbydown });

  return Shabbydown;

});


// artTemplate 包装
define('template', function (require: Require, exports: { [key: string]: string }) {

  const Template = require('./libs/art-template/lib/template-web');

  Template.defaults.imports.formatDate = function (date: Date, fmt: string): string {
    return new Date(date).format(fmt);
  };

  Template.defaults.imports.formatMoney = function (value: number, sign?: boolean): string {
    return Number.formatMoney(value, sign);
  };

  Object.defineProperty(exports, '__esModule', {value: true});
  Object.defineProperty(exports, 'Template', {value: Template});
  Object.defineProperty(exports, 'default', {value: Template});

});


// Hash插件，包含各种常用的Hash算法
define('hashes', function (require: Require) {

  const Hashes = require('/libs/jshashes/hashes.min.js');

  Object.defineProperty(Hashes, '__esModule', {value: true});
  Object.defineProperty(Hashes, 'Hashes', {value: Hashes});
  Object.defineProperty(Hashes, 'default', {value: Hashes});

  return Hashes;

});


define('qrcode', function (require: Require) {

  require('/libs/jquery.qrcode/jquery.qrcode.min.js');

  class QrCode {

    constructor() {
      throw new Error('This class can not be instantiated');
    }

    static create(target: HTMLElement, config: any) {
      (<any>$(target)).qrcode(config);
    }

  }

  Object.defineProperty(QrCode, '__esModule', {value: true});
  Object.defineProperty(QrCode, 'QrCode', {value: QrCode});
  Object.defineProperty(QrCode, 'default', {value: QrCode});

  return QrCode
});


define("wechat-sdk", function (require: Require) {

  let WeChatSdk = require("//res.wx.qq.com/open/js/jweixin-1.4.0.js");
  let Config = require("json!config").default;

  let isWeChatApp = navigator.userAgent.match(/micromessenger/i);

  function wechatsdk(callback: Function) {
    let exports = {};
    Object.defineProperty(exports, '__esModule', {value: true});
    Object.defineProperty(exports, 'WeChatSdk', {value: WeChatSdk});
    Object.defineProperty(exports, 'default', {value: WeChatSdk});

    WeChatSdk.isWeChatApp = isWeChatApp;

    if (!isWeChatApp)
      return callback(exports);

    let xhr = new XMLHttpRequest();

    xhr.open("post", Config.apis.remote + "/wechat/jsapi/signature", true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onreadystatechange = function () {
      if (xhr.readyState != 4) return;

      if (xhr.status != 200) {
        console.warn(`Faild to create  JSSDK signature: ${xhr.status}`);
        return callback(exports)
      }

      let config = JSON.parse(xhr.responseText);

      config.debug = Config.debug;
      config.appId = Config.mpmain.appId;
      config.jsApiList = [
        "showOptionMenu",
        "hideOptionMenu",
        "hideAllNonBaseMenuItem",
        "onMenuShareTimeline",
        "onMenuShareAppMessage",
        "closeWindow",
      ];

      WeChatSdk.config(config);

      // 浏览器模拟微信环境需要注释掉，直接写 callback(exports);
      // WeChatSdk.ready(function() {
      callback(exports);
      // });
    };

    xhr.send(JSON.stringify({url: location.href.split("#")[0]}));
  }

  wechatsdk.load = function (_name: string, _require: Require, onload: Function, config: any) {
    if (config.isBuild) {
      onload(null);
    } else {
      wechatsdk(onload);
    }
  };

  return wechatsdk;

});


// Periodical task.
define('periodical-task', function () {

  class PeriodicalTask {

    private readonly runnable: { run(): void };
    private readonly ms: number;
    private readonly repeat: number;

    private tid?: number = undefined;

    constructor(ms: number, repeat?: number, runnable?: { run(): void }) {
      this.runnable = runnable;
      this.ms = ms;
      this.repeat = repeat;
    }

    run(): void {
      // Default do nothing.
    }

    handler(): void {
      if (!this.repeat)
        delete this.tid;
      let runnable = this.runnable || this;
      runnable.run();
    }

    start(restart?: boolean): void {
      if (this.tid) {
        if (!restart)
          return;
        let stopFunc = this.repeat ? clearInterval : clearTimeout;
        stopFunc(this.tid);
      }
      let startFunc = this.repeat ? setInterval : setTimeout;
      this.tid = startFunc(this.handler.bind(this), this.ms);
    }

    stop(): void {
      if (!this.tid)
        return;
      let stopFunc = this.repeat ? clearInterval : clearTimeout;
      stopFunc(this.tid);
      delete this.tid;
    }

    get running() {
      return this.tid ? true : false;
    }

  }

  Object.defineProperty(PeriodicalTask, '__esModule', {value: true});
  Object.defineProperty(PeriodicalTask, 'PeriodicalTask', {value: PeriodicalTask});
  Object.defineProperty(PeriodicalTask, 'default', {value: PeriodicalTask});

  return PeriodicalTask;

});


// HTML parser.
define('html-parser', function () {

  class HTMLParser {

    private static readonly factroy = window.document.createElement('div');

    constructor() {
      throw new Error('This class can not be instantiated');
    }

    static parse(html: string): Array<HTMLElement> {
      HTMLParser.factroy.innerHTML = html;
      let children = HTMLParser.factroy.children, result: Array<HTMLElement> = [];
      for (let i = 0, child; child = children[i]; ++i)
        result.push(<HTMLElement>child);
      for (let i = 0, child; child = children[i]; ++i)
        HTMLParser.factroy.removeChild(child);
      return result;
    }

  }

  Object.defineProperty(HTMLParser, '__esModule', {value: true});
  Object.defineProperty(HTMLParser, 'HTMLParser', {value: HTMLParser});
  Object.defineProperty(HTMLParser, 'default', {value: HTMLParser});

  return HTMLParser;

});


interface Navigator {
  customizedLanguage: string
};

// A module usd to load specified NLS(Native Language Support) bundle.
define('nls', function (require: Require, exports: { [key: string]: any }) {

  interface Master {
    [key: string]: { [key: string]: string }
  };

  class NLSBundleLoader {

    private readonly bundle: string;
    private readonly languages: Array<string>;
    private readonly require: Require;
    private readonly onload: Function;
    private readonly parts: Array<string> = [];
    private readonly needed: Array<string> = [];

    private master: Master;

    constructor(bundle: string, languages: Array<string>, require: Require, onload: Function) {
      this.bundle = bundle;
      this.languages = languages;
      this.require = require;
      this.onload = onload;
    }

    load() {
      // Load master of NLS bundle.
      require([this.bundle + '/master'], this.onMasterLoaded.bind(this));
    }

    onMasterLoaded(master: Master) {
      let parts = this.parts, needed = this.needed, names: Array<string> = [];
      let languages = this.languages;

      this.master = master = <Master><unknown>master.default;

      // Checkout which stand-alone NLS parts need to load.
      for (let i = languages.length - 1; i >= 0; --i) {
        let language = languages[i];
        if (!language)
          continue;
        language = language.toLowerCase();
        let value = master[language];
        if (!value)
          continue;
        parts.push(language);
        if (typeof value === 'object')
          continue;
        needed.push(language);
        names.push(this.bundle + '/' + language);
      }

      // Load needed stand-alone NLS parts
      this.require(names, this.onPartsLoaded.bind(this));
    }

    onPartsLoaded() {
      let master = this.master, needed = this.needed, parts = this.parts;

      // Add add stand-along NLS part to master.
      for (let i = 0; i < needed.length; ++i)
        master[needed[i]] = arguments[i].default;

      // Mixin all locale parts into a bundle.
      let bundle: { [key: string]: string } = {'@name': this.bundle};
      for (let i = 0, source; source = master[parts[i]]; ++i)
        for (let prop in source)
          bundle[prop] = source[prop];

      // Create exports
      let exports = {};
      for (let prop in bundle)
        Object.defineProperty(exports, prop, {value: bundle[prop]});

      // Notify bundle loaded.
      Object.defineProperty(exports, '__esModule', {value: true});
      Object.defineProperty(exports, 'default', {value: exports});
      this.onload(exports);
    }

  }



  function load(name: string, require: Require, onload: Function, config: any) {
    if (config.isBuild)
      return onload(null)

    let languages = [];

    // Customized languages
    if (navigator.customizedLanguage)
      languages.push(navigator.customizedLanguage);

    // Browser languages
    if (navigator.language)
      languages.push(navigator.language);
    if (navigator.languages)
      languages = languages.concat(navigator.languages);

    // Default language
    languages.push('root');

    // Deduplicate
    let unique: Array<string> = [], map: { [key: string]: boolean } = {};
    for (let i = 0, lang; lang = languages[i]; ++i) {
      if (map[lang])
        continue;
      map[lang] = true;
      unique.push(lang);
    }
    languages = unique;

    // Load bundle.
    let loader = new NLSBundleLoader(name, languages, require, onload);
    loader.load();
  }

  exports.load = load;

});


// A module usd to load HTML snippets from an snippets file.
define('snippets', function (require: Require, exports: { [key: string]: any }) {

  const HTMLParser = require('html-parser').default;

  class SnippetsLoader {

    private readonly path: string;
    private readonly require: Require;
    private readonly onload: any;
    private readonly nlsphs: Array<any>;

    private html: string;

    constructor(path: string, require: Require, onload: Function) {
      this.path = path;
      this.require = require;
      this.onload = onload;
    }

    notifyError(text: string) {
      let error = new Error('Faild to load snippet file: ' + this.path + '(' + text + ').');
      this.onload.error(error);
    }

    load() {
      let xhr = new XMLHttpRequest();
      xhr.open('get', this.require.toUrl(this.path + '.html'), true);
      xhr.onreadystatechange = _evt => {
        if (xhr.readyState != 4)
          return;
        if (xhr.status != 200)
          return this.onHTMLNotLoaded(xhr);
        this.onHTMLLoaded(xhr);
      };
      xhr.send();
    }

    onHTMLLoaded(xhr: XMLHttpRequest) {
      let html = this.html = xhr.responseText;

      // Find all NLS placeholders.
      let matches = html.match(/\[nls\@[a-zA-Z0-9\-\/_]+:[a-zA-Z0-9\-_]+\]/g);

      // No NLS placeholders, mark ready and return.
      if (!matches || !matches.length)
        return this.onNLSResolved();

      // Prepare to load NLS bundles.
      let nlsphs = this.nlsphs, names: Array<string> = [], namemap: { [key: string]: boolean } = {};
      for (let i = 0, match; match = matches[i]; ++i) {
        let pair = match.substr(5, match.length - 6).split(':');
        nlsphs.push({
          match: match,
          name: pair[0],
          key: pair[1],
        });
        if (namemap[pair[0]])
          continue;
        namemap[pair[0]] = true;
        names.push('nls!' + pair[0]);
      }

      // Load NLS Bundles
      this.require(names, this.onNLSLoaded.bind(this));
    }

    onHTMLNotLoaded(xhr: XMLHttpRequest) {
      this.notifyError(xhr.status.toString());
    }

    onNLSLoaded() {
      let nlsphs = this.nlsphs, html = this.html;

      // Build a lookup map for loaded NLS bundles.
      let bundles: { [key: string]: any } = {};
      for (let i = 0, bundle; bundle = arguments[i]; ++i)
        bundles[bundle.default['@name']] = bundle.default;

      // Replace all NLS placeholders with NLS strings.
      for (let i = 0, nlsph; nlsph = nlsphs[i]; ++i)
        html = html.replace(nlsph.match, bundles[nlsph.name][nlsph.key]);

      this.html = html;
      this.onNLSResolved();
    }

    onNLSResolved() {
      let html = this.html, head = window.document.head, snippets = {};

      for (let i = 0, els = HTMLParser.parse(html), el; el = els[i]; ++i) {
        switch (el.tagName.toLowerCase()) {
          case 'style':
            head.appendChild(el);
            break;
          case 'script':
            if (el.type !== 'text/html' || !el.id)
              break;
            Object.defineProperty(snippets, el.id, {value: el.innerHTML.trim()});
            break;
          default:
            break;
        }
      }

      Object.defineProperty(snippets, '__esModule', {value: true});
      Object.defineProperty(snippets, 'default', {value: snippets});
      this.onload(snippets);
    }

  }

  function load(name: string, require: Require, onload: Function, config: any) {
    if (config.isBuild)
      return onload(null);

    let loader = new SnippetsLoader(name, require, onload);
    loader.load();
  };

  exports.load = load;

});

interface Window { _hmt: any; }

define('stats', function(require: Require) {

  const Config = require('json!config').default;
  const appId = Config.stats && Config.stats.appId;
  let _hmt;
  _hmt = window._hmt = _hmt || [];

  if (appId) {
    let script = document.createElement('script');
    script.src = `https://hm.baidu.com/hm.js?${appId}`;
    let s = document.getElementsByClassName("script")[0];
    s ? s.parentNode.insertBefore(script, s) : document.head.appendChild(script);
    console.log(script);
    
  } else {
    console.warn('Stats: missing appId in config.json');
  }

  class Stats {
    static track: (category: string, action: string, opt_label?: string, opt_value?: string) => any;

    constructor() {
      throw new Error('This class can not be instantiated');
    }

  }

  Stats.track = function(category: string, action: string, opt_label?: string, opt_value?: string) {
    return window._hmt.push(['_trackEvent', category, action, opt_label, opt_value]);
  };

  //category: 要监控的目标的类型名称，通常是同一组目标的名字，通常是同一组目标的名字，比如”视频”、”音乐”、”软件”、”游戏”等等。该项必选。
	//action: 用户跟目标交互的行为，如”播放”、”暂停”、”下载”等等。该项必选。
	//opt_label: 事件的一些额外信息，通常可以是歌曲的名称、软件的名称、链接的名称等等。该项可选。
	//opt_value：事件的一些数值信息，比如权重、时长、价格等等，在报表中可以看到其平均值等数据。该项可选

	//eg: Stats.track("左右脑开始页", "开始测试", "我相信你", 1);

  Object.defineProperty(Stats, '__esModule', {value: true});
  Object.defineProperty(Stats, 'Stats', {value: Stats});
  Object.defineProperty(Stats, 'default', {value: Stats});

  return Stats;

});


let mainScript = <HTMLScriptElement>window.document.querySelector('script[data-main]');
let base = mainScript.dataset.base;
requirejs.config({baseUrl: base});

// 页面主文件加载器，加载页面主文件并创建全局单例
define(function (require: Require) {

  // 解析Query参数并存放的location.args中，方便后续访问
  if (location.search) {
    let fields = location.search.substr(1).split('&');
    let args: { [key: string]: string } = {};

    for (let i = 0, field; field = fields[i]; ++i) {
      let kv = field.split('=');
      args[kv[0]] = decodeURIComponent(kv[1]);
    }

    location.args = args;
  } else {
    location.args = {};
  }

  // 设置根字体
  function setRootFontSize() {
    var width = document.documentElement.clientWidth || document.body.clientWidth
    document.documentElement.style.fontSize = width < 576 ? width / 375 * 16 + 'px' : '16px'
  }

  setRootFontSize()
  window.addEventListener('resize', () => setRootFontSize(), false)

  function loader(name: string, callback: Function) {
    // Load page class and init.
    require([name, 'libs/requirejs-domready/domReady!'], function (module: any) {
      let Class = module.default;
      let instance = new Class();
      instance.onDocumentReady();
      callback(instance);
      document.querySelector('body').style.visibility = "visible";
    });
  }

  loader.load = function (name: string, _require: Require, onload: Function, config: any) {
    if (config.isBuild)
      return onload(null)
    loader(name, onload);
  }

  return loader;

});
